export const TOS_UPDATED_AT = new Date('2025-02-05T16:15:33.771Z');
//# sourceMappingURL=tos.js.map